export class Rolemanagement {

Id: number;
DesignationId: number;
ModulesId: number;
ModulesName: string;
IsView  : boolean;
IsCreate  : boolean;
IsEdit  : boolean;
IsDelete  : boolean;
IsPrint  : boolean;
EmployeeId: number;
EmployeeBranchId: number;
CompanyId: number;
SaasId: string;
CreatedDate: Date;
ModifiedDate: Date;
IsActive  : boolean;
Flag : number;
ListByDesignationId : boolean;
}
